export default __webpack_public_path__ + "static/media/download-icon.51fc6ecc.svg";